import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS, GRID_REFETCH_INTERVAL_MS } from "../constants";
import { usePollingGate } from "./usePollingGate";

/**
 * DBCO-0059 (N-10) - the Final Loading Report. Refreshes about every 60 s while visible (the report is progressive until
 * Complete), never while a drawer holds the polling gate; a Modify refetches at once through its invalidation.
 */
export const useFinalLoadingReport = (operationId: string) => {
  const { busy } = usePollingGate();
  return useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.finalLoadingReport(operationId),
    queryFn: () => drybulkCargoOperationsService.finalLoadingReport(operationId),
    enabled: Boolean(operationId),
    retry: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchInterval: busy ? false : GRID_REFETCH_INTERVAL_MS,
    refetchIntervalInBackground: false,
  });
};
